import { flattenSubmission } from '../../../field-preview';
import { toPlainText } from '../../../services/rich-content';
import { INPUT_FIELD_TYPES } from '../../../constants';
function isServicesMultiChoice(submission) {
  const {
    fieldType,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.SERVICES_MULTI_CHOICE && (Array.isArray(value) || value === null);
}
export function formatServicesMultiChoice(submission) {
  if (isServicesMultiChoice(submission)) {
    return {
      label: toPlainText(submission.field.view.label),
      value: submission.value
    };
  }
  return undefined;
}
//# sourceMappingURL=services-multi-choice-preview.js.map